
import React, { useEffect, useState } from "react";
import axios from "axios";
import { PieChart, Pie, Tooltip, Legend, Cell, LineChart, Line, LabelList } from "recharts";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as BarTooltip,
  Legend as BarLegend,
} from "recharts";
import * as XLSX from "xlsx";
import { MdOutlineDownload } from "react-icons/md";
import { Select, Button } from "antd";
import useAuth from "../hooks/useAuth";

const { Option } = Select;
const URL = process.env.REACT_APP_API_URL;

const JobPositionPieChart = ({ vertical }) => {
  const { auth, setAuth } = useAuth();
  const [vacanciesData, setVacanciesData] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(vertical || '');
  const [clickedPosition, setClickedPosition] = useState([]);
  const [jobLocation, setJobLocation] = useState(null);
  const [positionData, setPositionData] = useState([]);
  const [onboardedCounts, setOnboardedCounts] = useState({});
  const { token } = useAuth();

  // useEffect(() => {
  //   console.log('clickedPosition: ', clickedPosition);
  // }, [clickedPosition])

  useEffect(() => {
    if (Array.isArray(vertical))
      setSelectedDepartment(vertical[1]);

    if (typeof vertical === 'string')
      setSelectedDepartment(vertical);

  }, []);

  const deptList = [
    "Data and Digital (DnD)",
    "PACS Project",
    "EdTech & Catalog Operations (ECO)",
    "Analytics n Insights (ANI)",
    "Adobe",
    "Shared Services",
    "Legal & Finance (LnF)"
    // "Business Development",
    // "Human Resources",
    // "Administration",
    // "IT & Governance",
  ];

  const vacancyStatusColors = {
    Selected: "#82ca9d",
    Rejected: "#f26680",
    'Shortlist to HR': 'brown',
    'L1 Assigned': "#8884d8",
    'L2 Assigned': "#83a6ed",
    Onboarded: "#8dd1e1",
    HR: "#a4de6c",
    Processing: "grey",
    'Screening Done': "violet",
  };

  useEffect(() => {
    const fetchVacanciesData = async () => {
      try {
        if (selectedDepartment) {

          const response = await axios.get(
            `${URL}/api/positions-with-vacancies/${selectedDepartment}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setVacanciesData(response.data.positions);

          const onboardedCounts = {};
          await Promise.all(
            response.data.positions.map(async (pos) => {
              const res = await axios.get(
                `${URL}/api/vacancy-status/${pos.position}`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
              const tempOnboardedCount = res.data.filter((item) => item._id === "Joined")
              const onboardedCount = tempOnboardedCount.reduce((acc, item) => acc + item.count, 0);
              onboardedCounts[pos.position] = onboardedCount;
            })
          );
          setOnboardedCounts(onboardedCounts);
        }
      } catch (error) {
        console.error("Error fetching vacancies data:", error);
      }
    };

    fetchVacanciesData();
  }, [selectedDepartment]);

  // useEffect(() => {
  //   const fetchPositionData = async () => {
  //     try {
  //       if (clickedPosition) {
  //         const response = await axios.get(
  //           `${URL}/api/vacancy-status/${clickedPosition[0]?.position}`,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${token}`,
  //             },
  //           }
  //         );
  //         console.log("response: ", response);
  //         console.log("response.data: ", response.data);
  //         const formattedData = response.data.reduce((acc, item, index) => {
  //           // console.log(index+1, "item: ");
  //           // console.log(item);
  //           acc[item._id] = item.count;
  //           // console.log("Result of "+(index+1)+" iteration:");
  //           // console.log(acc);
  //           return acc;
  //         }, {});
  //         console.log("formattedData: ");
  //         console.log(formattedData);
  //         setPositionData(prevData => {
  //           prevData.push(formattedData);
  //           return prevData;
  //         });
  //       }
  //     } catch (error) {
  //       console.error("Error fetching position data:", error);
  //     }
  //   };

  //   fetchPositionData();
  // }, [clickedPosition]);

  const handleDepartmentChange = (value) => {
    setSelectedDepartment(value);
    // console.log("selectedDepartment:");
    // console.log(selectedDepartment);

    setClickedPosition([]);
    setJobLocation(null);
    setPositionData([]);
  };

  // Get the desired label order
  // const labelOrder = mapping.map(m => m.label);

  // Now sort your bar chart data to match this order
  // const sortedBarChartData = positionData.slice().sort((a, b) => {
  //   return labelOrder.indexOf(a.name) - labelOrder.indexOf(b.name);
  // });

  // console.log(sortedBarChartData);


  const fetchPositionData = async (positionToFetch) => {
    try {
      if (clickedPosition) {
        const response = await axios.get(
          `${URL}/api/vacancy-status/${positionToFetch}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setPositionData(response.data);
        // const formattedData = response.data.reduce((acc, item, index) => {
        //   // console.log(index+1, "item: ");
        //   // console.log(item);

        //   if (!acc.interviewStatusData) {
        //     acc.interviewstatusData = {};
        //   }

        //   acc.interviewStatusData[item._id] = item.count;
        //   acc.vacancies = acc.vacancies + item.count;

        //   // console.log("Result of "+(index+1)+" iteration:");
        //   // console.log(acc);
        //   return acc;
        // }, { vacancies: 0, interviewStatusData: {}});
        // console.log("formattedData: ");
        // console.log(formattedData);
        // setPositionData([formattedData]);
      }
    } catch (error) {
      console.error("Error fetching position data:", error);
    }
  };

  const mapping = [
    { keywords: ['cv'], label: 'CV Process' },
    { keywords: ['test'], label: 'Test Process' },
    { keywords: ['l1'], label: 'L1 Process' },
    { keywords: ['l2'], label: 'L2 Process' },
    { keywords: ['l3'], label: 'L3 Process' },
    { keywords: ['salary'], label: 'Salary Discussion' },
    { keywords: ['documentation', 'documents'], label: 'Documentation' },
    { keywords: ['offer'], label: 'Offer Process' },
    { keywords: ['joining', 'joined', 'join', 'declined'], label: 'Joining Status' }
  ];


  const grouped = {};

  positionData.forEach(item => {
    const text = item._id.toLowerCase();
    const match = mapping.find(m =>
      m.keywords.some(keyword => text.includes(keyword))
    );
    console.log('match', match);

    const label = match ? match.label : 'Other';

    if (!grouped[label]) grouped[label] = 0;
    grouped[label] += item.count;
  });

  // Step 2: Create sorted bar chart data
  const orderedLabels = mapping.map(m => m.label); // enforce order
  const chartData = orderedLabels
    .map(label => ({
      name: label,
      value: grouped[label] || 0
    }))
    .filter(item => item.value > 0); // optional: hide empty bars

  // console.log(chartData);



  // const processedData = {};

  // positionData.forEach(({ _id, count }) => {
  //   const idLower = _id.toLowerCase();
  //   for (const { keywords, label } of mapping) {
  //     if (keywords.some(keyword => idLower.includes(keyword))) {
  //       if (!processedData[label]) processedData[label] = 0;
  //       processedData[label] += count;
  //       break; // Stop at the first matching category
  //     }
  //   }
  // });

  // const lineForLineChart = positionData;

  const handleClick = (data) => {
    console.log('data: ', data);
    console.log('vacanciesData: ', vacanciesData);

    const passingPosition = data.name;
    const position = vacanciesData.find((pos) => pos.position === data.name);
    console.log("position in handleClick: ");
    console.log(position);

    // setClickedPosition((prevData) => {
    //   if (prevData.length === 0) {
    //     prevData.push(position)
    //     return prevData;
    //   }
    // });

    setClickedPosition([position]);
    setJobLocation(position ? position.jobLocation : null);
    fetchPositionData(passingPosition);
  };

  const handleDownloadReport = async () => {
    try {
      const responsePositions = await axios.get(
        `${URL}/api/positions-with-vacancies/${selectedDepartment}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const positionsData = responsePositions.data.positions;

      const vacancyStatusPromises = positionsData.map(async (position) => {
        const response = await axios.get(
          `${URL}/api/vacancy-status/${position.position}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return { position: position.position, status: response.data };
      });

      const vacancyStatusData = await Promise.all(vacancyStatusPromises);

      const data = positionsData.map((positionData) => {
        const statusData = {};
        const positionStatus = vacancyStatusData.find(
          (item) => item.position === positionData.position
        );
        if (positionStatus) {
          positionStatus.status.forEach((status) => {
            statusData[status._id] = status.count;
          });
        }
        return {
          Department: selectedDepartment,
          Position: positionData.position,
          Vacancies: positionData.vacancies,
          ...statusData,
        };
      });

      const headers = [
        "Department",
        "Position",
        "Vacancies",
        ...Object.keys(vacancyStatusColors),
      ];
      const worksheet = XLSX.utils.json_to_sheet(data, { header: headers });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
      XLSX.writeFile(workbook, `${selectedDepartment}_Report.xlsx`);
    } catch (error) {
      console.error("Error downloading report:", error);
    }
  };

  const filteredVacanciesData = selectedDepartment ? vacanciesData.map((pos) => ({
    name: pos.position,
    value: pos.vacancies,
    positionId: pos.positionId || "N/A"
  })) : [];



  // let combinedVacanciesStatusData;

  // useEffect(() => {
  //   console.log('clickedPosition: ');
  //   console.log(clickedPosition);

  //   console.log(' useEfect formattedData positionData: ');
  //   console.log(positionData);

  //   const combinedVacanciesStatusData = [...clickedPosition, ...positionData];
  //   console.log("combinedVacanciesStatusData : ");
  //   console.log(combinedVacanciesStatusData);

  // }, [clickedPosition, positionData, selectedDepartment]);

  // const colors = [
  //   "#ffc658",
  //   "#ffb3ba",
  //   "#bae1ff",
  //   "#caffbf",
  //   "#ffd6a5",
  //   "#fdffb6",
  //   "#bdb2ff",
  //   "#a0c4ff",
  //   "#ffadad",
  //   "#d0f4de",
  //   "#f4bfbf",
  //   "#cafff9",
  //   "#c2f0fc",
  //   "#8884d8",
  //   "#83a6ed",
  //   "#8dd1e1",
  //   "#82ca9d",
  //   "#a4de6c",
  //   "#d0ed57",
  // ];

  const colors = [
    "#5A189A", // Deep purple
    "#006466", // Deep teal
    "#6A4C93", // Muted violet
    "#1B3A4B", // Dark steel blue
    "#7B2CBF", // Royal purple
    "#264653", // Blue slate
    "#8338EC", // Vivid indigo
    "#2A9D8F", // Teal green
    "#3A0CA3", // Strong blue-violet
    "#8E44AD", // Deep orchid
    "#0F4C5C", // Deep cyan
    "#006D77", // Slate teal
    "#5C4D7D", // Desaturated purple
    "#6D6875", // Dusty lavender
    "#4A4E69", // Charcoal violet
    "#1D3557", // Prussian blue
    "#457B9D", // Muted sky blue
    "#2C3E50", // Midnight navy
    "#5D3A00", // Earthy brown
  ];

  // const result = Object.entries(processedData).map(([key, value]) => ({
  //   _id: key,
  //   count: value
  // }));

  // console.log(result);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: "100%",
      }}
    >
      <div
        style={{
          paddingLeft: "5px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#FFFF",
          height: "50px",
          width: "100%",
          boxSizing: "border-box",
          boxShadow: "0px 1px 2px rgb(38, 39, 130)",
        }}
      >

        {(auth.role === "HiringManager" && Array.isArray(vertical)) && (
          <Select
            placeholder="Select Department"
            style={{ width: 240 }}
            value={selectedDepartment}
            onChange={handleDepartmentChange}
          // disabled={typeof vertical === "string"}
          // defaultValue={selectedDepartment}
          // allowClear
          >
            {/* {selectedDepartment} */}
            {vertical.map((ver) => (
              <Option key={ver} value={ver}>
                {ver}
              </Option>
            ))}
          </Select>
        )}

        {(auth.role === "HiringManager" && typeof vertical === 'string') && (
          <Select
            placeholder="Select Department"
            style={{ width: 240 }}
            value={selectedDepartment}
            // onChange={handleDepartmentChange}
            disabled={true}
            defaultValue={selectedDepartment}
          // allowClear
          >
            {selectedDepartment}
          </Select>
        )}

        {(auth.role === "Admin" || auth.role === "HR") && (
          <Select
            placeholder="Select Department"
            style={{ width: 240 }}
            value={selectedDepartment}
            onChange={handleDepartmentChange}
            // disabled={true}
            allowClear
          >
            {deptList.map((dept) => (
              <Option key={dept} value={dept}>
                {dept}
              </Option>
            ))}
          </Select>
        )}
        <Button
          className="add-button"
          style={{ background: "#A60808" }}
          onClick={handleDownloadReport}
        >
          <MdOutlineDownload />
          Download Report
        </Button>
      </div>
      <br />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          width: "98%",
          background: "white",
          padding: "10px",
          boxShadow: "0px 2px 4px rgb(38, 39, 130)"
        }}
      >
        {/* Pie Chart Section */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>
          <div style={{ textAlign: "center", marginBottom: "5px" }}>
            <h1>Job Vacancies by Position</h1>
            <p>Click on a segment to see detailed information about the position's status.</p>
          </div>
          {filteredVacanciesData && filteredVacanciesData.length > 0 ? (
            <PieChart width={400} height={400} cursor="pointer">
              <Pie
                dataKey="value"
                data={filteredVacanciesData}
                cx="50%"
                cy="50%"
                outerRadius={150}
                fill="#8884d8"
                label
                onClick={handleClick}
                style={{ outline: "none" }}
              >
                {filteredVacanciesData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={colors[index % colors.length]}
                    border="none"
                    strokeWidth={0}
                  />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          ) : (
            <div>No data available for the selected vertical</div>
          )}
        </div>

        {/* Bar Chart Section */}
        <div style={{ flex: 1, marginLeft: "10px" }}>
          {clickedPosition && clickedPosition.length > 0 ? (
            positionData.length > 0 && Object.keys(positionData[0]).length > 0 ? (
              <>
                <div
                  style={{
                    marginBottom: "10px",
                    padding: "5px",
                    background: "#f9f9f9",
                    textAlign: "center",
                    fontWeight: "bold",
                    border: "1px solid #cccccc",
                  }}
                >
                  {clickedPosition[0].position}, &nbsp; {clickedPosition[0].positionId || "Not Applicable for this position"}
                  {jobLocation && `, ${jobLocation}`}
                </div>

                {/* <div style={{ marginTop: '15px', paddingRight: '15px' }}>
                  <LineChart width={500} height={400} data={lineForLineChart}>
                    <XAxis dataKey="_id" />
                    <YAxis dataKey="count" allowDecimals={false}/>
                    <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                    <Tooltip />
                    <Legend />
                    <Line type="linear" dataKey="count" stroke="#8884d8" />
                  </LineChart>
                </div> */}

                <div style={{ marginTop: '35px', paddingRight: '15px' }}>
                  <BarChart width={630} height={350} data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis dataKey="value" allowDecimals={false} />
                    <BarTooltip />
                    {/* <BarLegend /> */}
                    <Bar dataKey="value" fill="#8884d8" >
                      <LabelList dataKey="value" position="top" fontSize={19} />
                      {
                        chartData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={colors[index % 20]} />
                        ))
                      }
                    </Bar>
                    {/* <Bar dataKey="count" fill="#8884d8" >
                      <LabelList dataKey="count" position="top" fontSize={19} />
                      {
                        positionData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={colors[index % 20]} />
                        ))
                      }
                    </Bar> */}
                  </BarChart>
                </div>
              </>
            ) : (
              <div
                style={{
                  alignItems: "center",
                  margin: "180px 0px 0px 30px",
                  color: "red",
                }}
              >
                No Applicant registered for {clickedPosition[0].position} yet
              </div>
            )
          ) : null}
        </div>
      </div>

    </div>
  );
};

export default JobPositionPieChart;